import { useAuth, userPoolIdFromAuthority } from '@bb/session-manager';

// biome-ignore lint/suspicious/noExplicitAny: @bb/session-manager's useAuth is untyped JS, matching the rest of the app's usage
type AnyData = any;

/**
 * True only for native (username/password) Cognito users on a tenant with inline SRP configured.
 * A user federated through an IdP mapped into the same Cognito pool carries an `identities` claim
 * in their ID token that native users never get — the cheapest way to tell them apart post-login,
 * with no extra request (fetchAuthMethod already answered this once, at login, for the
 * redirect-vs-inline branch).
 */
export function useCanChangePassword(): boolean {
  const { config, auth }: AnyData = useAuth();

  return (
    config?.provider === 'aws' &&
    !auth?.user?.profile?.identities &&
    Boolean(config?.oidcAuth?.clientId) &&
    Boolean(userPoolIdFromAuthority(config?.oidcAuth?.authority))
  );
}
